import React, { Fragment } from 'react';
import { IntlProvider } from 'react-intl';

import messages from './messages';
import { LOCALES } from '../constants';
import { translateRef } from './translate';

interface I18N {
  children: React.ReactNode;
  locale: string;
}

const Provider = ({ children, locale = LOCALES.PORTUGUESE }: I18N) => (
  <IntlProvider locale={locale} textComponent={Fragment} messages={messages[locale]} ref={translateRef}>
    {children}
  </IntlProvider>
);

export default Provider;
